module.exports = __webpack_public_path__ + "img/40_38_056_130.5ad5c15d.jpg";